import { Component } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { Router } from '@angular/router';

@Component({
    selector: 'app-create-app-dialog',
    templateUrl: './create.app.dialog.html',
    styleUrls: ['./create.app.dialog.css']
})
export class CreateAppDialog {
    constructor(
        private dialogRef: DynamicDialogRef,
        private router: Router
    ) { }

    createWithWizard(): void {
        this.dialogRef.close();
        this.router.navigate(['/dashboard/app-wizard']);
    }

    createWithBackend(): void {
        this.dialogRef.close();
        this.router.navigate(['/settings/layout/navigation/navi-overview']);
    }
}